import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useUXPContext } from '@core/context/useUXPContext';
import { ProgressBar } from '@widget/loaders';
/**
 * @export
 * Progress and failure feedback for an upload. Rendered by the field and by the
 * dialog's Upload source, which report the same thing in the same place.
 *
 * @advanced
 */
const UploadStatus = (props) => {
    const { isUploading, progress, uploadingIndex, uploadingTotal, error, children } = props;
    const context = useUXPContext();
    if (isUploading) {
        return _jsxs("div", { className: "uxpcore_mediapicker__upload-status", children: [_jsx(ProgressBar, { value: progress, indeterminate: !progress, showLabel: true }), (uploadingTotal || 0) > 1 &&
                    _jsx("span", { className: "uxpcore_mediapicker__upload-count", children: context.$L('uxp-core.media-picker.uploading-count', { current: uploadingIndex, total: uploadingTotal }) })] });
    }
    return _jsxs(_Fragment, { children: [error && _jsx("div", { className: "uxpcore_mediapicker__upload-error", children: error }), children] });
};
export default UploadStatus;
